export default {
    400: {
        title: "Hibás kérés",
        header: "@:views.errors.400.title",
        html: "Hibás kérés. Kérjük, próbálja meg később."
    },
    401: {
        title: "Hiba történt a bejelentkezés során",
        header: "@:views.errors.401.title",
        html: "Kérjük, vegye fel a kapcsolatot az <a href='{email}' target='_blank'>ügyfélszolgálattal</a> ."
    },
    404: {
        title: "Az oldal nem található",
        header: "@:views.errors.404.title"
    },
    403: {
        title: "Hozzáférés nem engedélyezett",
        header: "Hozzáférés nem engedélyezett",

        contact: "O-I A periféria csak alkalmazottak számára érhető el. Ha Ön alkalmazott és ezt az üzenetet látja, kérjük, a helyi Humánerőforrás- és Kultúra Osztályon keresztül frissítse az állapotát.",

        subject: "Felszerelés - Jogosultság",

        html: "<p class='text-start'> @:views.errors.403.contact</p>",
        error: {
            disabled: {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Jelenleg nem jogosult. További információért kérjük, vegye fel a kapcsolatot <a href='#' role='button' data-widget-trigger='{widgetOptions}'>az Ügyfélszolgálattal</a> .</p>"
            },
            "not-active": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Jelenleg nem jogosult. További információért kérjük, vegye fel a kapcsolatot a helyi People &amp; Culture szervezettel.</p>"
            },
            "not-allowed":{
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>O-I A periféria csak alkalmazottak számára érhető el. Ha Ön alkalmazott és ezt az üzenetet látja, kérjük, a helyi Humánerőforrás- és Kultúra Osztályon keresztül frissítse az állapotát.</p>"
            },
            "no-manager": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Nincs aktív vezető a ServiceNow profiljában. Kérjük, a vezető adatainak frissítéséhez vegye fel a kapcsolatot a helyi Human Rights &amp; Culture képviselőjével.</p>"
            },
            "self-manager": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>A ServiceNow profilodban Ön van beállítva a feletteseddel. Kérjük, a felettesed frissítéséhez fordulj a helyi Human &amp; Culture képviselőhöz.</p>"
            },
            "no-location": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Nincs megadva helyszín a ServiceNow profiljában. Kérjük, a helyszín frissítéséhez vegye fel a kapcsolatot a helyi People &amp; Culture képviselőjével.</p>"
            },
            eligibility: {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>O-I A periféria csak alkalmazottak számára érhető el. Ha Ön alkalmazott és ezt az üzenetet látja, kérjük, a helyi People &amp; Culture osztályon keresztül frissítsék az állapotát.</p>",
            },
            "eligibility-location": {
                header: "",
                html: "Köszönjük érdeklődését a(z) O-I Peripheral iránt. Jelenleg ez a program nem érhető el az Ön országában.",
            },
            "secondary-account": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Jelenleg egy másodlagos fiókkal próbálsz hozzáférni a(z) O-I perifériához. Kérjük, próbálj meg újra bejelentkezni az elsődleges fiókoddal.</p>"
            },
            "empty-core-id": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>A ServiceNow fiókodhoz nem tartozik fióknév. Kérjük, a fiókod frissítéséhez fordulj a helyi People &amp; Culture képviselőhöz.</p>"
            },
            country: {
                header: "@:views.errors.403.header",
                html: " @:views.errors.403.contact",
            },
            "no-permissions": {
                header: "Nincs hozzáférés",
                subject: "Nincs hozzáférés",
                html: "Nincs jogosultsága ennek az oldalnak a megnyitásához.",
            },
            "virtual-denied": {
                header: "Úgy tűnik, kicsit korán érkeztél...",
                html: "<p class='text-start'>Köszönjük érdeklődését a O-I Peripheral iránt. Úgy tűnik, hogy az engedélyezése és közvetlen meghívása előtt már elérte az oldalt. A O-I Peripheral bevezetése országonként és felhasználói csoportok szerint, szakaszosan történik. Az aktiválás után egy e-mailt fog kapni, amely személyes meghívót és utasításokat tartalmaz.</p><p class='text-start'> Kattintson az <a href='#' role='button' data-widget-trigger='{widgetOptions}'>Ügyfélszolgálat</a> gombra, ha kérdése vagy problémája van a rendelésével vagy a webhellyel kapcsolatban.</p>",
            }
        }
    },
    500: {
        title: "Váratlan hiba",
        header: "@:views.errors.500.title",
        message: "Hiba történt. Kérjük, próbálja meg később."
    },
    code: {
        title: "Váratlan hiba",
        message: "@:views.errors.code.title",
        error: "Hiba {code}."
    }
}